var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 345c-1 0-3 0-5-1L12 291c-3-2-6-4-8-7s-3-7-3-10V167c0-4 1-8 3-11l1-1 1-1c2-2 4-4 7-5l57-26V73c0-3 1-6 3-9 0-1 1-2 2-3 2-2 4-4 7-5L200 3c2-2 5-2 8-2 2 0 5 1 7 2l119 53c2 1 4 3 6 5l3 3c0 1 1 2 1 3 0 2 1 4 1 6v108c0 1 0 3-1 5l50 23c3 1 5 2 7 4 1 1 2 2 3 4v3c1 2 1 4 1 6v107c0 4-1 8-3 11s-5 5-9 7l-117 53c-2 1-4 1-6 1h-2c-3 0-5 0-8-1l-118-54c-3-1-5-3-7-5zM62 191v37l11-3c3 0 6 1 7 3l7 7v-32l-25-12zm40 19v45c0 2-1 4-2 6-4 2-8 2-11-1l-17-19-15 3h-2c-4 0-8-3-8-7v-53l-31-14v104s0 1 1 2l1 1 113 51V223l-29-13zm-46-38 14-7v-26l-42 20 28 13zm136 79v36l11-2c3-1 6 0 7 2l7 8v-32l-25-12zm33-1 112-51-3-1h-1l-111 51 3 1zm130-43-112 51 26 12 112-51-26-12zm-123 63v44c0 2-1 4-3 6-3 3-7 2-10-1l-17-19-16 3h-1c-4 0-8-3-8-7v-52l-31-14v105l2 2 113 51V283l-29-13zm20-234L142 87l23 11 109-52-22-10zM131 99l1 35 11-2c2 0 5 1 7 2l6 8v-32l-25-11zm161-45-110 52 26 12 112-52-28-12zm-121 63v45c0 2 0 4-2 6-3 2-8 2-11-1l-17-19-15 3h-2c-4 0-7-3-7-8l-1-51-31-15v103c0 1 0 2 1 3 0 0 1 1 2 1l112 51V131l-29-14zm-47-38 110-51-25-12h-3L96 66l28 13zm91 52v104l112-51c1 0 2-1 2-1 1-1 1-2 1-2V78l-115 53zm61 152v104l112-50 2-2V231l-114 52z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.62888a2f6ca74f55b0e9a43d766266fd.svg";
export { ForwardRef as ReactComponent };